<template>
    <div class="codebox">
        <span v-interact="copyScript" class="icon-interact codebox-action">
            <i aria-hidden="true" class="material-icons" role="img">file_copy</i>
        </span>
        <div ref="code" class="code">
            <slot/>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {copyContentToClipboard} from '@/library/clipboard';
    import TopMessageHandler from '../library/topMessageHandler';
    import {ref} from 'vue';
    const code  = ref<HTMLElement>();
    const copyScript = () =>
    {
        if (copyContentToClipboard(code.value))
        {
            TopMessageHandler.success('Der Inhalt wurde in die Zwischenablage kopiert');
        }
        else
        {
            TopMessageHandler.error('Der Inhalt konnte nicht in die Zwischenablage kopiert werden');
        }
    };
</script>